import { sendMessageComponent } from "./send-sms.component";
import { SendMessageService } from "./send-sms.service";

export const sendTextMessage = angular
  .module("components.sendTextMessage", [])
  .component("sendTextMessage", sendMessageComponent)
  .service("SendMessageService", SendMessageService)
  .config(($stateProvider) => {
    "ngInject";

    $stateProvider.state("send-text-message", {
      parent: "app",
      url: "/send-text-message",
      breadcrumbName: "Send Text Message",
      parentState: "home",
      component: "sendTextMessage",
      resolve: {
        membersData(UserService) {
          "ngInject";
          return UserService.getUserList({
            memberWithContactNumber: true,
            sortBy: "name_asc",
          });
        },
      },
    });
  }).name;



// WEBPACK FOOTER //
// ./src/app/components/send-sms/send-sms.module.js